export const collabHistorySidebarName = 'edit-post/collab-history-sidebar';
export const collabSidebarName = 'edit-post/collab-sidebar';
export const SIDEBARS = [ collabHistorySidebarName, collabSidebarName ];
